module.exports = __webpack_public_path__ + "assets/ParallelogramBy3MidpointsDetailed.91a5bcea633efe727b884635c8b4e7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ParallelogramBy3MidpointsDetailed.png
// module id = 546
// module chunks = 0